import * as yup from 'yup';

import { FormTypeCalculatorVehicleInfo } from '../actions/forms';
import errorText from './validationTexts';

export const vehicleInfoSchema: yup.ObjectSchema<FormTypeCalculatorVehicleInfo> = yup.object({
    vehicleRegistrationNumber: yup
        .string()
        .trim()
        .min(6, errorText.regNoRequired)
        .max(7, errorText.regNoRequired)
        .required(errorText.regNoRequired),

    odometerValue: yup.number(),
});
export default { vehicleInfoSchema };
